import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1bc0b7dc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc0b7dc')) {
      api.createRecord('1bc0b7dc', component.options)
    } else {
      api.reload('1bc0b7dc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1bc0b7dc&", function () {
      api.rerender('1bc0b7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JTVJsAeTZvJP/JS/offershelp.vue"
export default component.exports